import { InternalAxiosRequestConfig } from 'axios';

import { AXIOS_REQUEST, qaState } from './qaState';

const incrementRequests = () => {
    if (qaState === undefined) {
        return;
    }
    const value = qaState[AXIOS_REQUEST];
    qaState[AXIOS_REQUEST] = value + 1;
};

const decrementRequests = () => {
    if (qaState === undefined) {
        return;
    }
    const value = qaState[AXIOS_REQUEST];
    qaState[AXIOS_REQUEST] = value - 1;
};

export const requestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    incrementRequests();
    return config;
};

export const responseInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    decrementRequests();
    return config;
};

export const requestErrorHandler = (error: unknown): unknown => Promise.reject(error);

export const responseErrorHandler = (error: unknown): unknown => {
    decrementRequests();
    return Promise.reject(error);
};
